<template>
	<nav class="nav">
		<div class="nav-main">
			<div class="nav-main-top">
				<slot name="nav-top"/>
				<slot />
			</div>

			<div class="nav-main-bottom">
				<slot name="nav-bottom"/>
			</div>
		</div>

		<transition name="slide" mode="out-in">
			<div v-show="showSlide" class="nav-slide">
				<div class="nav-slide-header">
					<span class="nav-slide-header-text">{{customer}}</span>
					<t-icon-button
						class="nav-slide-header-button"
						icon="menu-closed"
						type="bp"
						appearance="transparent"
						iconSize="medium"
						size="large"
						@click="onClose"
					/>
				</div>

				<div class="nav-slide-inner">
					<div class="nav-slide-content">
						<slot name="nav-slide"/>
						<transition name="fade" mode="out-in">
							<component :is="activeNavItem.component" v-if="activeNavItem" />
						</transition>
					</div>

					<div class="nav-slide-footer">
						<svg
							version="1.1"
							class="nav-slide-footer-logo"
							fill="currentColor"
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							viewBox="0 0 562.7 131.7"
							enable-background="new 0 0 562.7 131.7"
							xml:space="preserve"
						>
							<g>
								<g>
									<path d="M45,78.2v53.4H29.8V78.2H0V66.6h74.9v11.6H45z"/>
									<path d="M95.4,131.6v-65h15.1v65H95.4z"/>
									<path d="M341,131.6v-65h66.5v11.1h-51.4v14.5h33.1v11.1h-33.1v16.1h52v12.2H341z"/>
									<path d="M473.7,97.9l33.2,33.8l-20.1-0.1l-23-23.2 M472.4,96.6 M463.3,87.5 M452.3,96.8l-30-30.1h20l19.8,19.6"/>
									<g>
										<polyline points="422.5,131.6 428.6,131.6 551.6,0 545.1,0 			"/>
										<polyline points="433.5,131.6 439.6,131.6 562.7,0 556.1,0 			"/>
									</g>
									<path
										d="M301.4,66.6H251v64.9h14.9v-25.3h35.6c0,0,19.5,1,19.5-19.9C321,65.7,301.4,66.6,301.4,66.6z M300.3,95.2l-34.4,0V77.7
										h34.4c0,0,9.1-0.3,9.2,8.7C309.5,95.6,300.3,95.2,300.3,95.2z"
									/>
									<path
										d="M211.4,66.6l-30.5,39.3l-30.5-39.3h-12.2v64.9h12.2V91.4c0-2-0.1-4.3-0.4-6.9c0.8,2.1,2.1,4.3,3.9,6.7l27,36l27-36
										c1.8-2.3,3-4.6,3.9-6.7c-0.3,2.6-0.4,4.9-0.4,6.9v40.1h12.1V66.6H211.4z"
									/>
								</g>
								<g>
									<path
										d="M526.8,130.1c-1,1-2.3,1.6-3.8,1.6c-1.5,0-2.7-0.5-3.8-1.6c-1-1-1.6-2.3-1.6-3.8c0-1.5,0.5-2.7,1.6-3.8
										c1-1,2.3-1.6,3.8-1.6c1.5,0,2.7,0.5,3.8,1.6c1,1,1.6,2.3,1.6,3.8C528.3,127.8,527.8,129.1,526.8,130.1z M519.7,123.1
										c-0.9,0.9-1.3,2-1.3,3.3c0,1.3,0.4,2.4,1.3,3.3c0.9,0.9,2,1.4,3.3,1.4c1.3,0,2.4-0.5,3.3-1.4c0.9-0.9,1.3-2,1.3-3.3
										c0-1.3-0.4-2.4-1.3-3.3c-0.9-0.9-2-1.4-3.3-1.4C521.7,121.7,520.6,122.2,519.7,123.1z M522.9,123.4c0.7,0,1.3,0.1,1.6,0.2
										c0.6,0.3,0.9,0.8,0.9,1.5c0,0.5-0.2,0.9-0.6,1.2c-0.2,0.1-0.5,0.2-0.8,0.3c0.5,0.1,0.8,0.3,1,0.6c0.2,0.3,0.3,0.6,0.3,0.9v0.4
										c0,0.1,0,0.3,0,0.4c0,0.2,0,0.3,0.1,0.3l0,0.1h-1c0,0,0,0,0-0.1c0,0,0,0,0-0.1l0-0.2v-0.5c0-0.7-0.2-1.1-0.6-1.3
										c-0.2-0.1-0.6-0.2-1.2-0.2h-0.8v2.3h-1v-5.9H522.9z M524,124.3c-0.3-0.1-0.7-0.2-1.3-0.2h-0.9v2.1h0.9c0.4,0,0.8,0,1-0.1
										c0.4-0.2,0.6-0.5,0.6-0.9C524.4,124.7,524.3,124.4,524,124.3z"
									/>
								</g>
							</g>
						</svg>
						<div class="nav-slide-footer-text">TMS</div>
					</div>
				</div>
			</div>
		</transition>

	</nav>
</template>

<script>
import TButton from '../../buttons/TButton';
import TIconButton from '../../buttons/TIconButton';
export default {
	name: 'TNav',
	components: { TButton, TIconButton },
	props: {
		showSlide: Boolean,
		customer: String,
		items: {
			type: Array,
			default: () => [],
		}
	},
	data() {
		return { activeNavItem: undefined };
	},
	provide() {
		return {
			toggleSlide: this.toggleSlide,
			setShowSlide: this.setShowSlide,
			isSlideShowing: this.showSlide,
		};
	},
	watch: {
		$route(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.setActiveNavItemByRoute(newVal);
			}
		}
	},
	mounted() {
		if (this.$route && this.items) {
			this.setActiveNavItemByRoute(this.$route);
			this.setShowSlide(false);
		}
	},
	methods: {
		onClose() {
			this.setShowSlide(false);
			this.$emit('change', false);
		},
		toggleSlide() {
			this.$emit('update:showSlide', !this.showSlide);
		},
		setActiveNavItem(navItem) {
			this.activeNavItem = navItem;
		},
		setShowSlide(value) {
			this.$emit('update:showSlide', value);
		},
		setActiveNavItemByRoute(route) {
			let pathArray = route.fullPath.split('/');
			let activeNavitem = this.items.find(navItem => navItem.menuProps.to === pathArray[1]);
			if (activeNavitem) {
				this.setActiveNavItem(activeNavitem);
			}
		}

	},
};
</script>

<style lang="scss" scoped>
	@import '~@/components/evergreen/scss/colors';
	@import '~@/components/evergreen/scss/text';
	.nav {
		position: relative;
		height: 100%;
		display: flex;
		flex-shrink: 0;
	}

	.nav-main {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		height: 100%;
		width: 40px;
		background-color: get-color($background, 'nav');
		z-index: 10;
	}

	.nav-main-top {
		margin-top: 18px;
		display: grid;
		grid-row-gap: 14px;
	}

	.nav-main-bottom {
		margin-bottom: 15px;
		display: grid;
		grid-row-gap: 10px;
	}

	.nav-slide {
		position: static;
		display: flex;
		flex-direction: column;
		padding: 0px 8px;
		width: 224px;
		height: 100%;
		background-color: get-color($background, 'nav-slide');
		transform: translateX(0);
		z-index: 9;
	}

	.nav-slide-header {
		display: flex;
		flex-shrink: 0;
		align-items: center;
		justify-content: space-between;
		margin: 12px 0px;
	}

	.nav-slide-header-text {
		@extend %text-large;
		font-size: 22px;
		font-weight: 500;
		color: get-color($text, 'default');
		margin-top: 0;
		margin-left: 16px;
		margin-right: 8px;
	}

	.nav-slide-header-button {
		margin-right: 8px;
	}

	.nav-slide-inner {
		overflow-y: auto;
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.nav-slide-content {
		flex: 1;
	}

	.nav-slide-footer {
		flex-direction: column;
		margin: 12px 16px;
	}

	.nav-slide-footer-logo {
		color: get-color($neutral-scale, 'N9');
		width: 100px;
	}

	.nav-slide-footer-text {
		@extend %text-small;
		font-weight: 600;
		margin-top: 0;
		color: get-color($text, 'muted');
	}

	.slide-enter-active, .slide-leave-active {
		transition: transform .2s ease-in-out;
	}

	.slide-enter, .slide-leave-to {
		transform: translateX(-100%);
	}

</style>

<docs>



```jsx noeditor
new Vue({
	data(){
		return {
			tripItems: [
				{description: 'Tursøk', icon: 'trip', iconType: 'timpex', bold: true},
				{description: 'Lokale turer', count: 3, isNew: false},
				{description: 'Faste turer', count: 0, isNew: false},
				{description: 'Turer uten oppdrag', count: 10, isNew: true},
				{description: 'Ny tur', icon: 'plus', bold: true}],
			orderItems: [
				{description: 'Oppdragssøk', icon: 'order', iconType: 'timpex', bold: true},
				{description: 'Nye inkomne', count: 3, isNew: true},
				{description: 'Mine oppdrag', count: 5, isNew: false},
				{description: 'Oppdrag med avvik', count: 1, isNew: true},
				{description: 'Nytt oppdrag', icon: 'plus', bold: true}],
			lastetorg: [
				{description: 'Kartvisning', icon: 'globe', bold: true},
				{description: 'Listevisning', icon: 'list', bold: true},
				{description: 'Eksterne', icon: 'comparison', bold: true}],

			showSlide: false,
		}
	},
	methods: {
		onClick() {
			this.showSlide = !this.showSlide;
		}
	},
	template: `
	<div style="display: flex; background: #f5f6f7;">
		<t-nav style="height: 750px; flex-shrink: 0;" customer="Kundenavn" :showSlide.sync="showSlide">
			<template v-slot:nav-top>
				<t-icon-button iconSize="xs" icon="box" type="bp" appearance="nav" @click="onClick"></t-icon-button>
				<t-icon-button iconSize="xs" icon="dollar" type="bp" appearance="nav" @click="onClick"></t-icon-button>
				<t-icon-button iconSize="xs" icon="th-derived" type="bp" appearance="nav" @click="onClick"></t-icon-button>
				<t-icon-button iconSize="xs" icon="search-text" type="bp" appearance="nav" @click="onClick"></t-icon-button>
			</template>

			<template v-slot:nav-bottom>
				<t-icon-button slot="nav-bottom" icon="settings" type="bp" appearance="nav" @click="onClick"></t-icon-button>
				<t-icon-button slot="nav-bottom" icon="user" type="bp" appearance="nav" @click="onClick"></t-icon-button>
			</template>

			<template v-slot:nav-slide>
				<t-menu>
					<t-menu-options-group title="Turer" :items="tripItems" v-slot="slotProps" bold>
						<t-menu-filter-option-item :icon="slotProps.item.icon" :iconType="slotProps.item.iconType" :value="slotProps.item" :count="slotProps.item.count" :selected="slotProps.isSelected"></t-menu-filter-option-item>
					</t-menu-options-group>

					<t-menu-divider :border="false" large/>

					<t-menu-options-group title="Oppdrag" :items="orderItems" bold>
						<template v-slot="slotProps">
							<t-menu-filter-option-item :icon="slotProps.item.icon" :iconType="slotProps.item.iconType" :value="slotProps.item" :count="slotProps.item.count" :selected="slotProps.isSelected"></t-menu-filter-option-item>
						</template>
					</t-menu-options-group>

					<t-menu-divider :border="false" large/>

					<t-menu-options-group title="Lastetorg" :items="lastetorg" v-slot="slotProps" bold>
						<t-menu-filter-option-item :icon="slotProps.item.icon" :value="slotProps.item" :selected="slotProps.isSelected"></t-menu-filter-option-item>
					</t-menu-options-group>
				</t-menu>
			</template>
		</t-nav>
		<t-pane background="tint2" style="width: 100%;" center>
			Content
		</t-pane>
	</div>
	`
});
```
</docs>